// CategoryHeader.jsx
import React from 'react';
import { ChevronRight } from 'lucide-react';
import "../../../../assets/css/customer/subscreens/category/CategoryPage.css";

const CategoryHeader = ({ 
  breadcrumb, 
  displayedProductsLength, 
  filteredProductsLength,
  isShopView,
  shopData 
}) => {
  return (
    <div className="content-header">
      <div className="page-breadcrumb">
        {breadcrumb.map((item, index) => (
          <React.Fragment key={item}>
            <span>{item}</span>
            {index < breadcrumb.length - 1 && <ChevronRight size={14} />}
          </React.Fragment>
        ))}
      </div>
      <p className="results-info">
        Showing <strong>{displayedProductsLength}</strong> of <strong>{filteredProductsLength}</strong> products
        {isShopView && shopData && (
          <span> from <strong>{shopData.shopName}</strong></span>
        )}
      </p>
    </div>
  );
};

export default CategoryHeader;